import {
  CLEAR_ACCOUNT_DETAILS,
  GET_ACCOUNT_DETAILS,
  GET_ACCOUNT_DETAILS_FAILURE,
  GET_ACCOUNT_DETAILS_SUCCESS,
} from '../actions'
import { INITIAL_ACCOUNT_DETAILS_STATE } from '../containers/contexts/search'
import { AccountDetails, AccountDetailsState } from '../types'

export const accountDetailsReducer = (
  state: AccountDetailsState = INITIAL_ACCOUNT_DETAILS_STATE,
  action: {
    type: string
    accountDetails?: AccountDetails
  }
) => {
  const { type, accountDetails } = action
  switch (type) {
    case GET_ACCOUNT_DETAILS:
      return { ...state, ...INITIAL_ACCOUNT_DETAILS_STATE, loadingResult: true }
    case GET_ACCOUNT_DETAILS_SUCCESS:
      return { ...state, ...INITIAL_ACCOUNT_DETAILS_STATE, accountDetails }
    case GET_ACCOUNT_DETAILS_FAILURE:
      return { ...state, ...INITIAL_ACCOUNT_DETAILS_STATE }
    case CLEAR_ACCOUNT_DETAILS:
      return INITIAL_ACCOUNT_DETAILS_STATE
    default:
      return state
  }
}
